import SupportReplyInput from './SupportReplyInput.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(
      config,
      'supportReplyInput',
      SupportReplyInput
    );
  },
};
